import { RequestAction, createRequestActionCreators, createPayloadAction } from 'helpers/actionsHelpers'
import { UserImageType, UserImageId } from 'interfaces/userImage'
import { ImageURLs } from 'interfaces/media'
import { PayloadAction } from 'interfaces/action'

type WithUserImageId = {
  id: UserImageId
}

type UserImageUploadRequest =
  & WithUserImageId
  & {
    type: UserImageType
    file: File
  }
type UserImageUploadResponse = {
  image: ImageURLs
}
export const USER_IMAGE_UPLOAD = 'USER_IMAGE_UPLOAD' as const
type UserImageUpload = RequestAction<typeof USER_IMAGE_UPLOAD, UserImageUploadRequest, UserImageUploadResponse>
export const userImageUploadActionCreator =
  createRequestActionCreators<typeof USER_IMAGE_UPLOAD, UserImageUploadRequest, UserImageUploadResponse>(USER_IMAGE_UPLOAD)

type UserImageLocalUpdatePayload =
  & WithUserImageId
  & {
    localImage: ImageURLs
  }
export const USER_IMAGE_LOCAL_UPDATE = 'USER_IMAGE_LOCAL_UPDATE' as const
export const userImageLocalUpdateActionCreator =
  (payload: UserImageLocalUpdatePayload): PayloadAction<typeof USER_IMAGE_LOCAL_UPDATE, UserImageLocalUpdatePayload> =>
    createPayloadAction(USER_IMAGE_LOCAL_UPDATE, payload)
type UserImageLocalUpdate = ReturnType<typeof userImageLocalUpdateActionCreator>

type UserImageActions =
  | UserImageUpload
  | UserImageLocalUpdate

export default UserImageActions
